import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class ChecklistUserService {
    static getAll(options=[]) {
        return new Promise((resolve, reject) => {
          let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
          axios.get(`${ROOT}checklists/users${params}`).then((response) => {
            resolve({ checklistUsers: response.data.content, page: response.data, response: response });
          }).catch((err) => {
            reject(err);
        });
      });
    }

    static get(checklistUserId) {
      return new Promise((resolve, reject) => {
        axios.get(`${ROOT}checklists/users/${checklistUserId}`).then((response) => {
          resolve({ checklistUser: response.data});
        }).catch((err) => {
          reject(err);
        });
      });
    }

    static add(checklistUser) {
      return new Promise((resolve, reject) => {
        axios.post(`${ROOT}checklists/users`, checklistUser).then((response) => {
          resolve({response: response});
        }).catch((err) => {
          reject(err);
        })
      })
    }

    static save(checklistUser) {
      return new Promise((resolve, reject) => {
        axios.patch(`${ROOT}checklists/users/${checklistUser.id}`, checklistUser).then((response) => {
          resolve({response: response});
        }).catch((err) => {
          reject(err);
        })
      })
    }

    static archive(checklistUserId) {
      return new Promise((resolve, reject) => {
        axios.delete(`${ROOT}checklists/users/${checklistUserId}`).then((response) => {
          resolve({response: response});
        }).catch((err) => {
          reject(err);
        })
      })
    }
}

export default ChecklistUserService;